module.exports = __webpack_public_path__ + "static/img/dynamic_banner.e3b74029.gif";